import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./exam.css";

export default function AddExam() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  // =========================
  // FORM STATE
  // =========================
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [date, setDate] = useState("");

  const [classes, setClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [allClasses, setAllClasses] = useState(true);

  const [saving, setSaving] = useState(false);

  // =========================
  // LOAD CLASSES
  // =========================
  const loadClasses = async () => {
    try {
      const res = await API.get("/school-admin/classes/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setClasses(res.data.classes || []);
    } catch (err) {
      alert("Failed to load classes");
    }
  };

  useEffect(() => {
    loadClasses();
  }, []);

  // =========================
  // TOGGLE CLASS SELECTION
  // =========================
  const toggleClass = (id) => {
    setSelectedClasses((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // =========================
  // SAVE EXAM
  // =========================
  const saveExam = async (e) => {
    e.preventDefault();

    if (!name.trim() || !subject.trim() || !date) {
      return alert("Exam name, subject & date are required");
    }

    if (!allClasses && selectedClasses.length === 0) {
      return alert("Please select at least one class");
    }

    try {
      setSaving(true);

      await API.post(
        "/school-admin/exams/create/",
        {
          name: name.trim(),
          subject: subject.trim() || "General", // ✅ CRITICAL FIX
          date,
          classes: allClasses ? [] : selectedClasses,
        },
        {
          headers: { "X-SCHOOL-ID": school.school.id },
        }
      );

      alert("✅ Exam created successfully");
      window.location.href = "/school-admin/exams";
    } catch (err) {
      console.error(err);
      alert("❌ Failed to create exam");
    } finally {
      setSaving(false);
    }
  };

  // =========================
  // UI
  // =========================
  return (
    <div className="page-container add-exam-page">
      <div className="page-header">
        <div>
          <h2 className="page-title">Add Exam</h2>
          <p className="page-subtitle">
            Create exam schedules and assign them to all or selected classes.
          </p>
        </div>
      </div>

      <form className="form-card" onSubmit={saveExam}>
        {/* EXAM NAME */}
        <label>Exam Name *</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Mid Term, Final Exam..."
          required
        />

        {/* SUBJECT */}
        <label>Subject *</label>
        <input
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Mathematics, Science, English..."
          required
        />

        {/* DATE */}
        <label>Exam Date *</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
        />

        {/* APPLY TO ALL CLASSES */}
        <div className="checkbox-row">
          <input
            type="checkbox"
            checked={allClasses}
            onChange={(e) => {
              setAllClasses(e.target.checked);
              setSelectedClasses([]);
            }}
          />
          <span>Apply to all classes</span>
        </div>

        {/* CLASS SELECTION */}
        {!allClasses && (
          <>
            <label>Select Classes *</label>

            <div className="class-checkbox-list">
              {classes.map((c) => (
                <label key={c.id} className="checkbox-item">
                  <input
                    type="checkbox"
                    checked={selectedClasses.includes(c.id)}
                    onChange={() => toggleClass(c.id)}
                  />
                  <span>{c.name}</span>
                </label>
              ))}
            </div>
          </>
        )}

        {/* SUBMIT */}
        <button className="btn-primary" disabled={saving}>
          {saving ? "Saving..." : "Save Exam"}
        </button>
      </form>
    </div>
  );
}
